<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Движение препарата</h5>
      </div>
      <div class="card-body">
        <div class="flex flex-wrap">
          <div
            v-for="store in storesForSelect"
            class="btn-group btn-group-toggle store_select"
            v-bind:class="[{ disabled: loading && selectedStore !== store.id }]"
          >
            <label
              v-bind:class="[
              { active: selectedStore == store.id },
              'btn btn-outline-primary']">
              <input
                :disabled="loading"
                @change="showData()"
                v-model="selectedStore"
                type="radio"
                :value="store.id"
                autocomplete="off"
              />
              <div>
                <p class="division_runner mb-0">{{ store.short_title }}</p>
              </div>
            </label>
          </div>
        </div>
        <div class="mt-3">
          <p>Выберите препарат</p>
          <DrugSearchNew
            ref="drugSearch"
            :onSelect="onDrugSelect"
          />
          <div class="alert alert-info p-2 mb-0 mt-1"
               v-if="selectedDrug && (selectedDrug.pack_box_comment || selectedDrug.pack_comment)">
            {{ selectedDrug.pack_box_comment }}
            {{ selectedDrug.pack_comment }}
          </div>
        </div>
        <div>
          <hr>
          <div class="form-group mb-1">
            <input @change="filterData" v-model="filter.in" type="checkbox" id="ch_1">
            <label for="ch_1" class="pointer">Показать приходы</label>
          </div>
          <div class="form-group mb-1">
            <input @change="filterData" v-model="filter.out" type="checkbox" id="ch_2">
            <label for="ch_2" class="pointer">Показать расходы</label>
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div class="card" v-if="!loading && drugData">
      <div class="card-body">
        <h5>Результат от: <strong>{{ revisionDate }}</strong> (остаток: <strong>{{ inStore }}</strong>)</h5>
        <DrugMoves
          :data="sortedData"
          :storeId="selectedStore"
          :inStore="inStore"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import DrugMoves from './components/DrugMoves'
import DrugSearchNew from "@/components/drugs/DrugSearchNew";

export default {

  components: {
    DrugSearchNew,
    DrugMoves,
  },
  computed: {
    $AllStores() {
      return this.$store.getters["platform/stores"];
    },
  },
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      selectedStore: 3,
      filter: {
        in: false,
        out: false,
      },
      drugData: null,
      sortedData: null,
      revisionDate: null,
      inStore: 0,
      selectedDrug: null,
      storesForSelect: [],
    }
  },
  mounted() {
    this.storesForSelect = [{
      id: 0,
      short_title: 'Все склады',
    },
      Object.values(this.$AllStores).find((s) => s.id === 2),
      Object.values(this.$AllStores).find((s) => s.id === 3),
      Object.values(this.$AllStores).find((s) => s.id === 10),
      {...Object.values(this.$AllStores).filter((s) => s.id === 4)[0], 'short_title': 'Почтовый'},
      ..._.orderBy(Object.values(this.$AllStores).filter((s) => ![1, 2, 3, 4, 10, 30].includes(s.id) && s.is_active), 'short_title'),
      Object.values(this.$AllStores).find((s) => s.id === 30),
      {...Object.values(this.$AllStores).find((s) => s.id === 1), 'short_title': 'Списание'}
    ];
    if (this.$route.query.drugId || this.$route.params.drugId) {
      this.selectedDrug = {id: this.$route.query.drugId || this.$route.params.drugId};
      this.selectedStore = this.$route.query.storeId || this.$route.params.storeId || 0;
      this.showData(true);
    }
  },
  methods: {
    filterData() {
      let records = {...this.drugData};
      if (this.filter.in || this.filter.out) {
        records = Object.keys(this.drugData).reduce((acc, timestamp) => {
          if (this.drugData[timestamp].type === 'invoice') {
            switch (this.drugData[timestamp].data.type_id) {
              case 1:
                if (this.filter.in) {
                  acc[timestamp] = {...this.drugData[timestamp]};
                }
                break;
              case 2:
                if (this.filter.in && this.drugData[timestamp].data.store_in === +this.selectedStore) {
                  acc[timestamp] = {...this.drugData[timestamp]};
                }
                if (this.filter.out && (this.drugData[timestamp].data.store_out === +this.selectedStore || this.drugData[timestamp].data.store_out === 1)) {
                  acc[timestamp] = {...this.drugData[timestamp]};
                }
                break;
              case 3:
                if (this.filter.out) {
                  acc[timestamp] = {...this.drugData[timestamp]};
                }
                break;
            }
          }
          return acc;
        }, {})
      }
      this.sortedData = records;
    },
    onDrugSelect(drug) {
      if (drug) {
        this.selectedDrug = drug;
      } else {
        this.selectedDrug = null;
      }
      this.showData();
    },
    async showData(getDrugData = false) {
      if (!this.selectedDrug) return;
      this.loading = true;
      if (this.$route.query.drugId) {
        this.$router.push({
          path: this.$route.path,
          query: {
            drugId: this.selectedDrug.id + '',
            storeId: this.selectedStore + ''
          }
        });
      }
      const {data} = await api.index(`drugs/movesData/${this.selectedDrug.id}?storeId=${this.selectedStore}&drug=${getDrugData}`);
      if (data.success) {
        if (data.drug) {
          this.$refs.drugSearch.drug = data.drug;
          this.selectedDrug = data.drug;
        }
        this.inStore = data.inStore;
        this.revisionDate = data.revisionDate;
        this.drugData = data.drugData;
        this.filterData();
      }
      this.loading = false;
    }
  }

}
</script>

<style scoped>
.store_select {
  margin-right: 3px;
  margin-bottom: 3px;
}

.store_select.disabled {
  opacity: 0.5;
}
</style>
